import { TypeRondeCodeEnum } from './TypeRondeCodeEnum';

export class TypeRonde {
  constructor(public readonly id: number, public readonly code: TypeRondeCodeEnum) {}
}
